import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { useToast } from '../hooks/use-toast';
import { Loader2 } from 'lucide-react';

export const QuoteForm = () => {
  const { toast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    empresa: '',
    telefone: '',
    origem: '',
    destino: '',
    tipoCarga: '',
    observacoes: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simula envio do formulário (integração de email será feita no backend)
    setTimeout(() => {
      toast({
        title: "Orçamento enviado com sucesso!",
        description: "Entraremos em contato em breve via WhatsApp.",
      });
      setIsSubmitting(false);
      setFormData({
        nome: '',
        empresa: '',
        telefone: '',
        origem: '',
        destino: '',
        tipoCarga: '',
        observacoes: ''
      });
    }, 1500);
  };

  return (
    <section id="orcamento" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card className="shadow-2xl border-0">
          <CardHeader className="text-center bg-gradient-to-r from-[#0A2540] to-[#8B3A9C] text-white rounded-t-lg">
            <CardTitle className="text-3xl md:text-4xl font-bold mb-2">
              Solicite seu Orçamento
            </CardTitle>
            <CardDescription className="text-gray-100 text-lg">
              Preencha o formulário e receba uma proposta personalizada
            </CardDescription>
          </CardHeader>
          <CardContent className="pt-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <Label htmlFor="nome">Nome Completo *</Label>
                  <Input 
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                    placeholder="Seu nome"
                    className="border-2 focus:border-[#8B3A9C]"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="empresa">Empresa</Label>
                  <Input 
                    id="empresa"
                    name="empresa"
                    value={formData.empresa}
                    onChange={handleChange}
                    placeholder="Nome da empresa"
                    className="border-2 focus:border-[#8B3A9C]"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="telefone">Telefone / WhatsApp *</Label>
                <Input 
                  id="telefone"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                  required
                  placeholder="(11) 99999-9999"
                  className="border-2 focus:border-[#8B3A9C]"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <Label htmlFor="origem">Origem *</Label>
                  <Input 
                    id="origem"
                    name="origem"
                    value={formData.origem}
                    onChange={handleChange}
                    required
                    placeholder="Cidade - Estado"
                    className="border-2 focus:border-[#8B3A9C]"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="destino">Destino *</Label>
                  <Input 
                    id="destino"
                    name="destino"
                    value={formData.destino}
                    onChange={handleChange}
                    required
                    placeholder="Cidade - Estado"
                    className="border-2 focus:border-[#8B3A9C]"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="tipoCarga">Tipo de Carga *</Label>
                <Input 
                  id="tipoCarga"
                  name="tipoCarga"
                  value={formData.tipoCarga}
                  onChange={handleChange}
                  required
                  placeholder="Ex: Móveis, Eletrônicos, Alimentos"
                  className="border-2 focus:border-[#8B3A9C]"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="observacoes">Observações</Label>
                <Textarea 
                  id="observacoes"
                  name="observacoes"
                  value={formData.observacoes}
                  onChange={handleChange}
                  placeholder="Detalhes adicionais sobre a carga, dimensões, peso, etc."
                  rows={4}
                  className="border-2 focus:border-[#8B3A9C]"
                />
              </div>

              <Button 
                type="submit" 
                disabled={isSubmitting}
                className="w-full bg-[#F4D03F] hover:bg-[#e6c236] text-[#0A2540] font-bold py-6 text-lg"
              >
                {isSubmitting ? (
                  <>
                    <Loader2 className="mr-2 h-5 w-5 animate-spin" />
                    Enviando...
                  </>
                ) : (
                  'Solicitar Orçamento'
                )}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
